import GroupNotes from './GroupNotes';
import GroupNotesContainer from './GroupNotes.container';

export default GroupNotesContainer(GroupNotes);
